import React, { useState } from "react";
import { Card, CardHeader, Grid, IconButton, Typography } from "@mui/material";
import { useApp } from "context";
import { IBroadcast } from "interfaces";
import { Helpers } from "utils";
import { Custom } from "components";
import CloseIcon from "@mui/icons-material/Close";

type Props = {};

export const Announcement = (props: Props) => {
  const { locale, service, t, theme } = useApp();
  const [index, setIndex] = useState(0);
  const [announcement, setAnnouncement] = useState<IBroadcast>(
    {} as IBroadcast
  );
  const [announcements, setAnnouncements] = useState<IBroadcast[]>([]);
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  const [incrementComponent, setIncrementComponent] = useState<number>(0);

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await service.broadcast.session();
      setAnnouncements(response);
      if (response.length > 0) {
        setAnnouncement(response[0]);
      }
    };
    fetchData();
  }, [incrementComponent]);

  async function handleAction(broadcastId: number) {
    await service.broadcast.read(broadcastId);
    setIncrementComponent(incrementComponent + 1);
  }

  return (
    <>
      {announcements.length > 0 && (
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12}>
            <Custom.Card>
              <CardHeader
                sx={{ padding: 0 }}
                action={
                  <IconButton
                    onClick={() => handleAction(announcement.broadcastId)}
                    sx={{ color: theme.palette.font.color }}
                  >
                    <CloseIcon />
                  </IconButton>
                }
                title={
                  <Typography
                    component="div"
                    sx={{
                      textAlign: "left",
                      fontSize: theme.font.md,
                      color: theme.palette.font.color,
                    }}
                  >
                    {announcement.content}
                  </Typography>
                }
                subheader={
                  <Typography
                    component="div"
                    sx={{
                      fontSize: theme.font.sm,
                      color: theme.palette.font.accent,
                    }}
                  >
                    {Helpers.interpolate(t.message.broadcast.received_at, {
                      date: Helpers.toRelativeDate(
                        announcement.broadcastTime,
                        t.relative_date,
                        locale,
                        true
                      ),
                    })}
                  </Typography>
                }
              />
            </Custom.Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};
